import * as React from 'react';
import LinkifyIt from 'linkify-it';
import tlds from 'tlds';
import { matchTags } from '@Utils/parsingUtils';
const linkify = new LinkifyIt();
linkify.tlds(tlds);

import defaultLinkDecorator from './decorators/defaultLinkDecorator';
import { Tag } from '../Tag';

export function Marker({ linkDecorator, TagDecorator, children }) {
    const matchLinks = str => {
        return linkify.match(str);
    };

    const parseString = string => {
        if (string === '') {
            return string;
        }

        const matches = [...(matchLinks(string) || []), ...(matchTags(string) || [])];

        if (!matches) {
            return string;
        }

        const elements = [];
        let lastIndex = 0;

        matches.sort((a, b) => (a.index > b.index ? 1 : -1)).forEach((match, i) => {
            // Push preceding text if there is any
            if (match.index > lastIndex) {
                elements.push(string.substring(lastIndex, match.index));
            }
            let decoratedComponent;
            if (match.url) {
                decoratedComponent = linkDecorator(match.url, match.text, i);
            } else {
                decoratedComponent = <TagDecorator text={match.text} key={i} />;
            }

            elements.push(decoratedComponent);

            lastIndex = match.lastIndex;
        });

        // Push remaining text if there is any
        if (string.length > lastIndex) {
            elements.push(string.substring(lastIndex));
        }

        return elements.length === 1 ? elements[0] : elements;
    };

    // eslint-disable-next-line  no-shadow
    const parse = (children, key) => {
        if (typeof children === 'string') {
            return parseString(children);
        } else if (
            React.isValidElement(children) &&
            children.type !== 'a' &&
            children.type !== 'button'
        ) {
            return React.cloneElement(children, { key: key }, parse(children.props.children));
        } else if (Array.isArray(children)) {
            return children.map((child, i) => parse(child, i));
        }

        return children;
    };

    return <React.Fragment>{parse(children)}</React.Fragment>;
}

Marker.defaultProps = {
    linkDecorator: defaultLinkDecorator,
    TagDecorator: Tag
};
